<template>
  <div class="position-absolute button-container">
    <div class="trail-map-buttons">
      <div v-for="button in buttons" :key="button.id">
        <template v-if="button.enabled">
          <template v-if="button.clear">
            <button class="btn btn-sm btn-clear rounded-pill d-flex align-items-center ml-2" @click="buttonClicked(button.id)">
              {{ button.name }}
            </button>
          </template>
          <template v-else>
            <button :class="['btn', 'btn-sm', 'rounded-pill', 'd-flex', 'align-items-center', { 'btn-primary-action': button.primary }]" @click="buttonClicked(button.id)">
              <div :class="['d-flex', 'align-items-center', 'justify-content-center', { 'pr-1': button.name }]">
                <span class="material-icons">{{ button.icon }}</span>
              </div>
              <div>
                {{ button.name }}
              </div>
            </button>
          </template>
        </template>
        <template v-else>
          <button :class="['btn', 'btn-sm', 'rounded-pill', 'd-flex', 'align-items-center', { 'btn-primary-action': button.primary }]" @click="buttonClicked(button.id)">
            <div :class="['d-flex', 'align-items-center', 'justify-content-center', { 'pr-1': button.name }]">
              <span class="material-icons">{{ button.icon }}</span>
            </div>
            <div>
              {{ button.name }}
            </div>
          </button>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    buttons: {
      type: Array,
      required: true,
    },
    buttonClicked: {
      type: Function,
      required: true,
    },
  },
});
</script>

<style>
.button-container {
  width: fit-content;
  top: 60px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 600;
}

button {
  white-space: nowrap;
}

.btn-success {
  color: #fff;
}

.btn-primary-action {
  background-color: #ffc107 !important;
  color: #000;
  border-color: #ffc107;
  font-weight: 600;
}

.btn-primary-action:hover {
  background-color: #e0a800;
  border-color: #d39e00;
  color: #000;
}

.btn-primary-action:focus,
.btn-primary-action:active {
  background-color: #d39e00;
  border-color: #c69500;
  color: #000;
  box-shadow: 0 0 0 0.2rem rgba(255, 193, 7, 0.5);
}

@media (max-width: 900px) {
  .backButton {
    left: 14%;
  }
}

.mapboxgl-ctrl-top-right {
  top: 60px !important;
}

@media (max-width: 420px) {
  .button-container{
    top: 48px;
    padding: 10px 0px;
    width: 100%;
    left: 0;
    transform: none;
  }
}
</style>
